<template>
  <Select
    :modelValue="modelValue"
    :options="ENROLLMENT_STATUS_OPTIONS"
    optionLabel="label"
    optionValue="value"
    :placeholder="placeholder"
    :class="className"
    :size="size"
    :showClear="showClear"
    :data-testid="dataTestid"
    @update:modelValue="onUpdate"
    @change="onChange"
  />
</template>

<script setup lang="ts">
import { ENROLLMENT_STATUS_OPTIONS } from '@/utils/enrollmentStatus';
import type { EnrollmentStatusEnum } from '@/types/composition-functions';

withDefaults(
  defineProps<{
    modelValue: EnrollmentStatusEnum | null | undefined;
    placeholder?: string;
    className?: string;
    size?: 'small' | 'large' | undefined;
    showClear?: boolean;
    dataTestid?: string;
  }>(),
  {
    placeholder: 'All Statuses',
    className: 'w-full rounded-lg',
    size: undefined,
    showClear: true,
    dataTestid: 'filter-enrollment-status',
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: EnrollmentStatusEnum | null];
  change: [event: unknown];
}>();

const onUpdate = (value: EnrollmentStatusEnum | null) => emit('update:modelValue', value);
const onChange = (event: unknown) => emit('change', event);
</script>
